
import styles from './styles.module.scss';
const Card = (props) => {

    let bck;

    switch(props.background){
        case 0:
        bck = "Blackout";
        break;
        case 1:
        bck = "Dark";
        break;
        case 2:
        bck = "Medium";
        break;
        case 3:
        bck = "Light";
        break;
        case 4:
        bck = "Loreful";
        break;
         case 5:
        bck = "Gartenlore";
        break;
    }
    
    
    return (
        <div className={`${styles['nc-card']} ${styles[`backgroundColor` + bck]} ${props.xmas && styles['backgroundColor' + bck + '--xmas']} ${props.halloween && styles['backgroundColor' + bck + '--halloween']}`}
        style={{
            width: props.width,
            height: props.height
        }}
        >
            <div className={`${styles['nc-card-pic']}`}
                style={{
                    background: `url(${props.image}) center/cover no-repeat`
                }}>            
            </div>
               <div className={`${styles['nc-card-title']}`}>{props.title}</div>
                  <div className={`${styles['nc-card-desc']}`}>{props.desc}</div>
        </div>
    );
}


export default Card;